import { useMemo } from 'react'

import { useGetSenderIds } from './use-get-sender-ids'

export const useGetCallerOptions = () => {
  const result = useGetSenderIds()

  const callerIds = useMemo(() => {
    const data = result.data
    const source = Array.isArray(data) ? data : data?.voice || []

    return source.map(({ phonenumber, sender, name }) => ({
      label: name ? `${name} (${sender || phonenumber})` : sender || phonenumber,
      value: sender || phonenumber,
    }))
  }, [result.data])

  return {
    callerIds,
    isLoading: result.isLoading,
  }
}
